// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ONRX","newExpiryDate":"styles_newExpiryDate__q8jQ2","footer":"styles_footer__1KYrL"};